import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

// Initialize Mixpanel
export const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    console.warn("Mixpanel token not found. Analytics disabled.");
    return;
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    track_pageview: false, // We'll track manually for more control
    persistence: "localStorage",
    // Session Replay Config
    record_sessions_percent: 100,
    record_mask_text_selector: ".sensitive-data",
    record_idle_timeout: 300000,
    // Heatmap, Rage Click & Dead Click Tracking
    record_heatmap_data: true,
  });

  // Identify user from JWT
  identifyUser();

  // Register super properties
  mixpanel.register({
    platform: "webview",
    session_id: generateSessionId(),
    entry_time: new Date().toISOString(),
  });
};

// Identify user from JWT token
export const identifyUser = () => {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));

    mixpanel.identify(String(payload.id));
    mixpanel.people.set({
      user_id: payload.id,
      country_code: payload.country_code,
      phone_number: payload.phone_number,
    });

    mixpanel.register({
      user_id: payload.id,
    });
  } catch (error) {
    console.error("Failed to decode JWT:", error);
  }
};

// Generate unique session ID
const generateSessionId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

// Track event helper
export const trackEvent = (eventName, properties = {}) => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.track(eventName, {
    timestamp: new Date().toISOString(),
    ...properties,
  });
};

// Track screen view
export const trackScreen = (screenName, properties = {}) => {
  trackEvent(`${screenName}`, properties);
};

// Time tracking utilities
let pageStartTime = null;

export const startPageTimer = () => {
  pageStartTime = Date.now();
};

export const getPageTimeSpent = () => {
  if (!pageStartTime) return 0;
  return Date.now() - pageStartTime;
};

export const trackPageTimeSpent = (pageName) => {
  const timeSpent = getPageTimeSpent();
  if (timeSpent > 0) {
    trackEvent("wall_page_time_spent", {
      page_name: pageName,
      duration_ms: timeSpent,
    });
  }
  pageStartTime = null;
};

// Session end tracking
export const setupSessionEndTracking = () => {
  const sessionStart = Date.now();
  let pagesVisited = 0;
  let hotspotsClicked = 0;

  window.addEventListener("beforeunload", () => {
    trackEvent("wall_session_ended", {
      total_duration_ms: Date.now() - sessionStart,
      pages_visited: pagesVisited,
      hotspots_clicked: hotspotsClicked,
    });
  });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      trackEvent("wall_session_ended", {
        total_duration_ms: Date.now() - sessionStart,
        pages_visited: pagesVisited,
        hotspots_clicked: hotspotsClicked,
      });
    }
  });

  return {
    incrementPagesVisited: () => pagesVisited++,
    incrementHotspotsClicked: () => hotspotsClicked++,
  };
};

export default mixpanel;
